import { I18N_PREFIX } from './../constants';

const SPORTS_CLASS_BLOCK_NAME = 'bb-inplay-sport';
export const SPORT_TITLE_CLASS_NAME = `${SPORTS_CLASS_BLOCK_NAME}__title`;

export const TOURNAMENT_CLASS_BLOCK_NAME = 'bb-inplay-tournament';
export const TOURNAMENT_EVENTS_CLASS_NAME = `${TOURNAMENT_CLASS_BLOCK_NAME}__events`;
export const TOURNAMENT_ID_HTML_ATTR_NAME = 'data-tournament-id';

export const TOP_MENU_SCHEDULE_TEXT = `${I18N_PREFIX}.schedule`;

export const SCHEDULE_MENU_LINK_TODAY_TEXT = `${I18N_PREFIX}.today`;
export const SCHEDULE_MENU_LINK_UP_NEXT_TEXT = `${I18N_PREFIX}.up_next`;

export const SPORT_EVENT_COUNTER_CHANGE_EVENT = 'inplay:sport::event:counter:increased';

export const GTM_ATTRIBUTE_NAME = 'data-spectate-product';
export const GTM_ATTRIBUTE_INPLAY = 'inplay';
export const GTM_ATTRIBUTE_WIDGET_SUFFIX = '-widget';
export const GTM_ATTRIBUTE_LIVE_NOW = 'live-now';
export const GTM_ATTRIBUTE_SCHEDULE = 'schedule';
export const GTM_ATTRIBUTE_ALL_SPORTS = 'all-sports';
export const GTM_ATTRIBUTE_GO_TO_SCHEDULE = 'go-to-schedule';
export const GTM_ATTRIBUTE_UP_NEXT = 'up-next';
export const GTM_ATTRIBUTE_TODAY = 'today';


export const FIRST_INDEX = 0;
export const GOAL_SCORER_MAX_SELECTION_EXPANDED = 4;
export const OVER_UNDER_MAX_SELECTION_EXPANDED = 4;
export const MAX_SELECTION_ROWS_NOT_EXPANDED = 5;
export const HOME = '1';
export const DRAW = 'x';
export const VISITANT = '2';
export const THREE_WAY_MARKET_HEADERS = [HOME, DRAW, VISITANT];
